import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AppRoute from './routes/route';
import { authProtectedRoutes, publicRoutes } from './routes';
import ErrorPage from './components/Error';
import LegacyLayout from './layout/LegacyLayout';

function App() {
  return (
    <React.Fragment>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={route.component}
            key={idx}
            exact={true}
          />
        ))}

        {/* Protected Routes */}
        {authProtectedRoutes.map((route, idx) => {
          // Check if this is a module route (doesn't need legacy layout)
          const isModuleRoute = route.path.includes('-module') || 
                                route.path === '/modules' || 
                                route.path === '/comptoire' || 
                                route.path === '/comptoire/list' || 
                                route.path === '/dashboard' ||
                                route.path === '/';
          
          return (
            <Route
              path={route.path}
              element={
                <AppRoute requiredRoles={route.roles}>
                  {isModuleRoute ? route.component : <LegacyLayout>{route.component}</LegacyLayout>}
                </AppRoute>
              }
              key={idx}
              exact={true}
            />
          );
        })}

        {/* Error Page */}
        <Route path="/error" element={<ErrorPage />} />

        {/* Catch-all Route for Undefined Paths */}
        {/* <Route path="*" element={<Navigate to="/error?status=404&message=Page%20Not%20Found" />} /> */}
      </Routes>
    </React.Fragment>
  );
}

export default App;
